/** Entry point of the phase E ximen package (Ximending and Longshan Temple). Imported once from main.ts. */
import '../render/propsXimen';
import './ximen';
import { registerNpcs } from '../world/npcs';
import { NPCS_XIMEN } from '../world/npcsXimen';

registerNpcs(NPCS_XIMEN);
